module.exports = __webpack_public_path__ + "img/daily.f36c717f.svg";